import type { RouterConfig } from "@nuxt/schema";

// Commercial routes should always land at the top of the page — readers expect a fresh
// scroll position when they click a nav link or hit "back" onto a marketing page.
// Docs pages keep the default browser-restored position so a long article's scrollback
// still works for back/forward navigation within the docs tree.
function isDocsPath(path: string): boolean {
  return /^\/[^/]+\/docs(\/|$)/.test(path);
}

export default <RouterConfig>{
  scrollBehavior(to, _from, savedPosition) {
    if (to.hash) {
      return new Promise((resolve) => {
        function tryScroll(attempts: number) {
          const el = document.querySelector(to.hash) as HTMLElement | null;
          if (el) {
            el.scrollIntoView({ behavior: "smooth" });
            resolve(false);
          } else if (attempts > 0) {
            requestAnimationFrame(() => tryScroll(attempts - 1));
          } else {
            resolve({ top: 0 });
          }
        }
        requestAnimationFrame(() => tryScroll(20));
      });
    }

    if (!isDocsPath(to.path)) {
      // Commercial pages scroll to top inside the page transition's onAfterLeave
      // (app.vue) — while the view is faded out — so the jump never shows.
      // Returning false stops Nuxt from scrolling again after the transition.
      return false;
    }

    if (savedPosition) {
      return savedPosition;
    }
    return { top: 0 };
  },
};
